module.exports = __webpack_public_path__ + "img/traspasar.b7eb34f5.svg";